// @ts-strict-ignore
// deprecation notice! We will change to using a team path like "team-name:first-portfolio-level:second-level:third" to simplify routes

// The team path is a string following a colon separated list of portfolio paths
export const teamPathParameterName = 'teamPath';

// LEGACY - We used to have PORTFOLIO_PATH_SEPARATOR eq '/', but this makes url handling difficult, and using
//          a double-dash or colon is better for that reason.
export const firstPortfolioPathParameterName = 'firstPortfolioPath';
export const secondPortfolioPathParameterName = 'secondPortfolioPath';
export const thirdPortfolioPathParameterName = 'thirdPortfolioPath';

export const portfolioPathParameterNames = [
    firstPortfolioPathParameterName,
    secondPortfolioPathParameterName,
    thirdPortfolioPathParameterName,
];
export const teamAndPortfolioPathParameterNames = [
    teamPathParameterName,
    ...portfolioPathParameterNames,
];
export const projectPathParameterName = 'projectPath';

export const PORTFOLIO_PATH_SEPARATOR = ':';

export type RouteParamsV6 = 'teamPath' | 'projectPath';

export type RouteParams = {
    // The team path is a string following a PORTFOLIO_PATH_SEPARATOR-separated list of portfolio paths
    teamPath?: string | null | undefined;
    projectPath?: string | null | undefined;
};
export type ParsedRouteParams = {
    firstPortfolioPath?: string | null | undefined;
    secondPortfolioPath?: string | null | undefined;
    thirdPortfolioPath?: string | null | undefined;
    teamPath?: string | null | undefined;
    projectPath?: string | null | undefined;
};
export function fromParsedParams(parsedParams: ParsedRouteParams): RouteParams {
    return {
        teamPath: teamAndPortfolioPathParameterNames
            .map((name) => parsedParams[name])
            .filter(Boolean)
            .join(PORTFOLIO_PATH_SEPARATOR),
        projectPath: parsedParams.projectPath,
    };
}
export function parseRouteParams(routeParams: RouteParams): ParsedRouteParams {
    if (!routeParams.teamPath) {
        return routeParams;
    }
    const [
        teamPath,
        firstPortfolioPath,
        secondPortfolioPath,
        thirdPortfolioPath,
    ] = routeParams.teamPath.split(PORTFOLIO_PATH_SEPARATOR);
    return {
        ...routeParams,
        teamPath,
        firstPortfolioPath,
        secondPortfolioPath,
        thirdPortfolioPath,
    };
}

export function getPortfolioFullPathFromArray(paths: ReadonlyArray<string>) {
    if (paths.length === 0) {
        throw new Error(
            'At least 1 path segment (team/main portfolio path) is required',
        );
    }
    return paths.filter(Boolean).join(PORTFOLIO_PATH_SEPARATOR);
}

export function getPortfolioFullPath(props: RouteParams): string {
    const paths = teamAndPortfolioPathParameterNames
        .map((name) => props[name])
        .filter(Boolean);
    return paths.join(PORTFOLIO_PATH_SEPARATOR);
}

/**
 * @param props - params object from navigation
 * @returns  will return only portfolio path without team. You HAVE TO use it for portfolio API
 */
export function getLastPortfolioPath(props: RouteParams | ParsedRouteParams) {
    const params =
        firstPortfolioPathParameterName in props
            ? props
            : parseRouteParams(props);
    return (
        params[thirdPortfolioPathParameterName] ??
        params[secondPortfolioPathParameterName] ??
        params[firstPortfolioPathParameterName] ??
        ''
    );
}

/**
 * @param props - params object from navigation
 * @returns will return only portfolio path OR team if no portfolio or empty string. Use it for navigation
 */
export function getLastSectionPath(props: RouteParams) {
    const lastPortfolio = getLastPortfolioPath(props);
    return lastPortfolio !== ''
        ? lastPortfolio
        : (props[teamPathParameterName] ?? '');
}

export function getTeamPath(props: RouteParams) {
    return props[teamPathParameterName] ?? '';
}

export function getProjectPath(props: RouteParams) {
    return props[projectPathParameterName] ?? '';
}

/**
 * @param params - params object from navigation
 * @returns will return last portfolio path, team path and project path from navigation
 */
export function getQueryVariablesFromParams(params: RouteParams) {
    const lastPortfolioPath = getLastPortfolioPath(params);
    const teamPath = getTeamPath(params);
    const projectPath = getProjectPath(params);

    return { lastPortfolioPath, teamPath, projectPath };
}
